<!--
 * @Description: 
 * @Author: 琢磨先生
 * @Date: 2022-10-24 18:34:34
 * @LastEditors: 琢磨先生
 * @LastEditTime: 2022-10-24 19:09:22
-->
<template>
    <router-view></router-view>
</template>

 